import { PrismicNextLink } from '@prismicio/next';
import { Content } from '@prismicio/client';
import { useState } from 'react';
import { AnimateLinkText } from '@/components';
import { Simplify } from '../../../../../../prismicio-types';
import styles from './getOfferProducts.module.scss';
import AnimationContainer from '@/components/Animation/AnimationContainer';

interface Props {
  variation: 'withProducts' | 'onlyProducts' | 'productsWithButton';
  isVisible: boolean;
  index: number;
  item: Simplify<Content.GetOfferSliceWithProductsPrimaryProductsItem>;
  animation: object;
}

const Product = ({ variation, isVisible, index, item, animation }: Props) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <PrismicNextLink
      field={item.link}
      className={`${styles.card} ${styles[variation]} ${isVisible ? styles.isVisible : ''}`}
      key={item.heading}
      style={{ transitionDelay: `${index * 0.13}s` }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className={styles.animationWrapper}>
        <AnimationContainer
          animation={animation}
          loop={false}
          isActive
          play={isHovered}
        />
      </div>
      <div className={styles.card_text}>
        <p className={styles.product}>{item.heading}</p>
        <p className={styles.description}>{item.description}</p>
        <AnimateLinkText
          text={item.link_text as string}
          styles={styles.link_text}
        />
      </div>
    </PrismicNextLink>
  );
};

export default Product;
